var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 92,
    viewBox: "0 0 64 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1801 0C27.128 2.86124 0 17.7177 0 17.7177V33.4545L30.6205 51.2823V92H39.0774V46.7923L8.52279 29.1187V21.9435L32.1801 8.84785C57.9901 23.066 60.9116 24.6727 60.9116 24.6727V15.8029C48.8962 9.26603 32.1801 0 32.1801 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1365 21.0192L23.3721 25.8393L53.729 42.5665V56.7407L47.7543 59.1838V68.89C51.4226 66.8651 55.5302 65.4565 60.9119 62.5072V49.5216V36.8661C50.7197 31.2536 32.1365 21.0192 32.1365 21.0192Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0214844 47.1665L0.0434503 56.8947L21.7678 68.8899V59.2277L0.0214844 47.1665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logoWhite.0fdf4fa1dac37d5d5c385401280ce4c8.svg";
export { ForwardRef as ReactComponent };